/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

// NOTE: This component was custom styled specifically to match the comp, but if we begin using this highlighted image component in other places in the future, we will want to revisit how all of the sizing is handled so that it can work universally.

export const DivStyledContainer = styled.div`
  ${({ theme, backgroundVariant }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();

    let borderThickness = rem(5);
    let borderColor = theme.colors.neutral.white;
    let marginBottom = rem(65);
    let thisWidth = '100%';

    if(xlargeUp){
      borderThickness = rem(30);
      marginBottom = 0;
    } else if(largeUp){
      borderThickness = rem(25);
      marginBottom = rem(10);
    } else if(mediumUp){
      borderThickness = rem(15);
      marginBottom = rem(10);
    } else if(smallUp){
      marginBottom = rem(35);
    }

    if(xlargeUp){
      thisWidth = rem(280);
    }else if(largeUp){
      thisWidth = rem(220);
    }else if(mediumUp){
      thisWidth = rem(180);
    }

    // border must match section BG color. white/lightA is default
    if(backgroundVariant === 'lightB'){
      borderColor = theme.colors.neutral.grayLight3;
    }else if(backgroundVariant === 'lightC'){
      borderColor = theme.colors.neutral.grayLight2;
    }else if(backgroundVariant === 'sky'){
      borderColor = theme.colors.sky.sky;
    }else if (backgroundVariant === 'darkDefault'){
      borderColor = theme.colors.blue.blue;
    }

    return css`
      position: relative;
      margin: 0 auto ${marginBottom};
      border-radius: 50%;
      border: ${borderThickness} solid ${borderColor};
      width: ${thisWidth};
      height: auto;
    `;
  }}
`;

export const DivStyledDecorativeLineContainer = styled.div`
  ${({ theme, backgroundVariant, lastChild }) => {
    const mediumUp = theme.mediumUp();
    let thisBorder = `${rem(1)} solid ${theme.colors.red.red}`;
    const thisBorderHeight = rem(190);

    if (backgroundVariant === 'darkDefault'){
      thisBorder = `${rem(1)} solid ${theme.colors.neutral.white}`;
    }

    return css`
      position: relative;
      ::before {
        ${lastChild && 'display: none;'};
        content: '';
        position: absolute;
        width: ${mediumUp ? rem(300) : 0};
        height: ${mediumUp ? 0 : thisBorderHeight};
        border-bottom: ${mediumUp ? thisBorder : 'none'};
        border-left: ${mediumUp ? 'none' : thisBorder};
        top: 50%;
        left: 50%;
      }
    `;
  }}
`;

export const DivStyledTagContainer = styled.div`
  ${({ theme, backgroundVariant }) => {
    const containerTopPos = '-27%';
    const containerLeftPos = '-37%';
    const thisScale = '28%';
    let thisBackgroundColor = theme.colors.sky.sky;

    if (backgroundVariant === 'darkDefault'){
      thisBackgroundColor = theme.colors.sky.skyDark1;
    }

    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: ${containerTopPos};
      left: ${containerLeftPos};
      color: ${theme.colors.blue.blue};
      background-color: ${thisBackgroundColor};
      height: 100%;
      width: 100%;
      transform: scale(${thisScale});
      border-radius: 50%;
      text-align: center;
    `;
  }}
`;

export const PictureStyled = styled(Picture)`
  ${({ theme, backgroundVariant }) => {
    const xlargeUp = theme.xlargeUp();
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let borderThickness = rem(7);
    let thisBorderColor = theme.colors.sky.skyLight1;

    if (backgroundVariant === 'darkDefault'){
      thisBorderColor = theme.colors.sky.sky;
    }

    if(xlargeUp){
      borderThickness = rem(15);
    }else if(mediumUp){
      borderThickness = rem(10);
    } else if(smallUp){
      borderThickness = rem(8);
    }

    return css`
      border-radius: 50%;
      border: ${borderThickness} solid ${thisBorderColor};
      img {
        border-radius: 50%;
      }
    `;
  }}
`;

export const TypographyStyled = styled(Typography)`
  transform: scale(300%);
`;
